export const EMBED_URL_PARAM_NAME = 'embed';
export const EMBED_MODE_STORAGE_KEY = 'embedMode';
export const EMBED_CLASS_NAME = 'emma-embed';
